<div class="blue-color"></div>
<div class="yellow-color"></div>
